import React from 'react';
import { RegisterView } from 'src/app/views';
import { useMultiStepFormContext } from 'src/lib/MultiStepForm';
import { useStepSubmit } from 'src/screens/Common/Checkout/hooks/useStepSubmit';
import { useRegisterFormContext, useStepTemplateLogic } from '../hooks';
import { useLogin } from '../../Login/hooks';

export const RegisterForm = () => {
  const { steps, activeStepId } = useMultiStepFormContext();
  const { values } = useRegisterFormContext();
  const { singIn } = useLogin({ redirectOnSuccess: '/register/success', msgOnSuccess: 'Registro completado!' });

  const currentStep = steps.find((step) => step.id === activeStepId) ?? steps[0];

  const { handleStepSubmit } = useStepSubmit({ currentStep });

  useStepTemplateLogic(currentStep);

  return (
    <RegisterView
      steps={steps}
      activeStep={steps.findIndex((s) => s.id === activeStepId)}
      email={values.accountInfo.email}
      handlerSocialSingIn={singIn}
      onContinue={handleStepSubmit}
    />
  );
};
